/**
 *
 * @param {string} birthdate
 * @returns {boolean}
 */
export function validateBirthdate(birthdate) {
  const regex = /^(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])\/\d{4}$/

  if (!regex.test(birthdate)) {
    return false
  }

  const [month, day, year] = birthdate.split('/').map(Number)
  const birthDateObj = new Date(year, month - 1, day)
  const today = new Date()

  let age = today.getFullYear() - birthDateObj.getFullYear()
  const monthDiff = today.getMonth() - birthDateObj.getMonth()

  if (
    monthDiff < 0 ||
    (monthDiff === 0 && today.getDate() < birthDateObj.getDate())
  ) {
    age--
  }

  return age >= 18
}
